/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_Vault_ContentInputs */

const en_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Vault Content`)
};

const es_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido exclusivo de bóveda`)
};

const fr_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de coffre-fort exclusif`)
};

const de_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusiver Vault-Inhalt`)
};

const ja_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫の限定コンテンツ`)
};

const zh_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专属金库内容`)
};

const ar_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى الخزنة الحصري`)
};

const id_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten Vault Eksklusif`)
};

const it_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto Esclusivo del Vault`)
};

const ru_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивный контент из Хранилища`)
};

const pt_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo Exclusivo do Cofre`)
};

const ko_exclusive_vault_content = /** @type {(inputs: Exclusive_Vault_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault 독점 콘텐츠`)
};

/**
* | output |
* | --- |
* | "Exclusive Vault Content" |
*
* @param {Exclusive_Vault_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_vault_content = /** @type {((inputs?: Exclusive_Vault_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_Vault_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_vault_content(inputs)
	if (locale === "es") return es_exclusive_vault_content(inputs)
	if (locale === "fr") return fr_exclusive_vault_content(inputs)
	if (locale === "de") return de_exclusive_vault_content(inputs)
	if (locale === "ja") return ja_exclusive_vault_content(inputs)
	if (locale === "zh") return zh_exclusive_vault_content(inputs)
	if (locale === "ar") return ar_exclusive_vault_content(inputs)
	if (locale === "id") return id_exclusive_vault_content(inputs)
	if (locale === "it") return it_exclusive_vault_content(inputs)
	if (locale === "ru") return ru_exclusive_vault_content(inputs)
	if (locale === "pt") return pt_exclusive_vault_content(inputs)
	return ko_exclusive_vault_content(inputs)
});